import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';
import { createLocale } from '../../utils.js';

const locales = {
  en: createLocale(en, 'lossReasons'),
  uk: createLocale(uk, 'lossReasons'),
  pl: createLocale(pl, 'lossReasons'),
  ru: createLocale(ru, 'lossReasons'),
  es: createLocale(es, 'lossReasons'),
  uz: createLocale(uz, 'lossReasons'),
  hi: createLocale(hi, 'lossReasons'),
};

export default locales;
